module.exports = __webpack_public_path__ + "img/diagram_15_1.be1786e6.png";